<template>
  <div>
    <van-nav-bar :title="generateCustomizeString('customerList')" @click-right="onClickRight" :sticky="true" fixed>
      <van-icon name="search" size="20px" slot="right" />
    </van-nav-bar>
    <customer-list style="margin-top: 46px; margin-bottom: 48px;"></customer-list>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { Field, Cell, CellGroup, Row, Col, Button, NavBar, Icon } from 'vant'
import CustomerList from './components/CustomerList'

export default {
  name: 'customers',
  components: {
    [Cell.name]: Cell,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    CustomerList
  },
  data() {
    return {

    }
  },
  methods: {
    generateCustomizeString,
    onClickRight() {
      this.$router.push({ name: 'CustomersSearch' })
    }
  },
  created: function() {

  }
}
</script>

<style scoped>
</style>
